import {useEffect, useState} from 'react';
import {AlmNotesMApping} from '../services/notes';

const useNotesTabDataHook = (isCommentEmpty?:any) => {
  // const [notesTabData, setNotesTabdata] = useState<any>([]);
  const [notesData, setnotesData] = useState<any>([]);
  const [loading, setLoading] = useState(true);

 const noteDataMapping = async () => {
   try {
     setLoading(true);
     const res: any = await AlmNotesMApping(); // Fetch the notes data
     setnotesData(res?.data?.notesMapping); // Update state with fetched data
   } catch (error) {
     console.error("Error fetching notes data:", error);
   } finally {
     setLoading(false);
   }
 };
  
  useEffect(() => {
    noteDataMapping();
  }, [isCommentEmpty]);
  // useEffect(() => {
  //   const programWiseData =
  //     notesData
  //       ?.filter((res: any) => {
  //         return res?.programName;
  //       })
  //       .map((res: any) => res?.courseList)
  //       .flat(1) || [];
  //   const libraryData =
  //     notesData?.filter((res: any) => {
  //       return res?.contextId;
  //     }) || [];
  //   setNotesTabdata([...libraryData, ...programWiseData]);
  // }, [notesData]);
  return {
    // notesTabData,
    notesData,
    noteDataMapping,
    loading,
  };
};

export default useNotesTabDataHook;
